module.exports = __webpack_public_path__ + "static/media/ylyhk.79efa8a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/ylyhk.png
// module id = 2183
// module chunks = 0